import React from 'react';
import SocialHistoryInfo from 'pages/Dashboard/pages/Charts/pages/Details/components/SocialHistories/SocialHistoryInfo';
import {
  socialHistoryData,
} from 'core/constants';
import {
  Props as TabProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/types/tabContentProps';
import {
  getAge,
} from 'utils/misc';

type Parts = 'title';

type Props = Pick<TabProps, 'patient'> & {
  classes?: Partial<Record<Parts, string>>;
};

export default function SocialHistories({ patient }: Props) {
  const { value: age } = getAge(patient?.dateOfBirth ?? '', 'year');
  const socialHistoryQuestions = age < 65 ? socialHistoryData.slice(0, 2) : socialHistoryData;
  return (
    <div className="flex flex-col gap-4">
      {socialHistoryQuestions?.map((info) => (
        <SocialHistoryInfo
          key={info?.id}
          info={info}
        />
      ))}
    </div>
  );
}
